import uuidv4 from 'uuid';
import cookies from 'js-cookie';
import ApiManager from '../api/manager';
import savedShoppingCartTemplate from '../templates/saved-shopping-carts-template';
// import jsonToView from '../api/json-to-view';

class SaveShoppingCart {
  constructor(options = {}) {
    this.config = {
      saveModule: () => document.querySelectorAll('[data-module="saveShoppingCartForm"]'),
      displayModule: () => document.querySelector('[data-module="savedShoppingCarts"]'), // element to dispaly list of all stored shopping carts
      cartId: cookies.get('cartId'),
      ...options
    };
    this.apiManager = new ApiManager();
  }

  init() {
    const { displayModule, saveModule } = this.config;

    if (saveModule()) {
      saveModule().forEach(el =>
        el.addEventListener('submit', event => this.saveCart(event), true)
      );
    }

    if (displayModule()) {
      this.displayCarts(displayModule());
    }
  }

  getCarts() {
    return this.apiManager.get('/api/v2/preference/user/?key=savedCarts').then(response => {
      // No user preferences
      if (!response.length) {
        return null;
      }

      // No data
      if (!response[0].value) {
        return [];
      }

      return JSON.parse(decodeURI(response[0].value));
    });
  }

  setCart(event) {
    const element = event.target;
    const { cartId } = element.dataset;

    // set new cookie and local storage of cart
    localStorage.setItem('cartId', cartId);
    cookies.set('cartId', cartId);

    this.deleteCartById(cartId, () => window.location.assign('/winkelwagen'));
  }

  deleteCart(event) {
    const element = event.target;
    const { cartId } = element.dataset;

    this.deleteCartById(cartId, () => window.location.reload());
  }

  saveCart(event) {
    event.preventDefault();
    const form = event.target;
    const cartName = form.querySelector('[name="cartName"]').value;

    if (!cartName) return;

    this.getCarts().then(savedCarts => {
      const cartId = cookies.get('cartId');
      const currentCart = {
        cartName,
        cartId,
        cartDate: SaveShoppingCart.getCurrentDate()
      };

      if (savedCarts != null) {
        if (SaveShoppingCart.containsCartId(currentCart, savedCarts)) {
          const alertHtml = `<div class="alert alert-info alert-dismissible" role="alert">Huidige winkelwagen is al opgeslagen in mijn projecten. <a href="/mijn-account/mijn-projecten">Bekijk project</a></div>`;
          const submitButton = form.querySelector('[type="submit"]');
          form.insertAdjacentHTML('afterbegin', alertHtml);
          submitButton.setAttribute('disabled', 'disabled');
          return; // if cart already in saved carts skip rest of function
        }
        savedCarts.push(currentCart);
        const json = encodeURI(JSON.stringify(savedCarts));
        const patchValue = JSON.parse(`[{"op":"replace","path":"/value","value":"${json}"}]`);
        this.apiManager
          .patch('/api/v2/preference/user/savedCarts', patchValue)
          .then(response => response)
          .then(() => {
            cookies.set('cartId', uuidv4(), null, '/'); // create new cart
            window.location.href = '/mijn-account/mijn-projecten'; // redirect to my projects page
          });
      } else {
        const json = encodeURI(JSON.stringify([currentCart]));
        const postValue = JSON.parse(`{"key":"savedCarts","value":"${json}","type":"string"}`);
        this.apiManager
          .post('/api/v2/preference/user', postValue)
          .then(response => response)
          .then(() => {
            cookies.set('cartId', uuidv4(), null, '/'); // create new cart
            window.location.href = '/mijn-account/mijn-projecten'; // redirect to my projects page
          });
      }
    });
  }

  async displayCarts(element) {
    element.classList.add('is-loading');
    this.getCarts().then(async savedCarts => {
      if (savedCarts != null && savedCarts.length) {
        // order array by cartname ASC
        savedCarts.sort((a, b) => {
          const cartA = a.cartName.toLowerCase();
          const cartB = b.cartName.toLowerCase();
          if (cartA < cartB)
            // sort string ascending
            return -1;
          if (cartA > cartB) return 1;
          return 0; // default return value (no sorting)
        });

        const cartApiCalls = savedCarts.map(cart =>
          this.apiManager
            .get(`/api/v1/catalog/cart/${cart.cartId}`)
            .then(data => ({
              cartName: cart.cartName,
              cartDate: cart.cartDate,
              cartId: cart.cartId,
              cartData: data
            }))
            .catch(() => ({
              cartName: cart.cartName,
              cartDate: cart.cartDate,
              cartId: cart.cartId,
              cartData: null
            }))
        );

        const allCarts = await Promise.all(cartApiCalls);
        const htmlELements = allCarts.map(cart => {
          const { cartData, cartName, cartDate } = cart;
          if (!cartData) {
            return '';
          }
          return savedShoppingCartTemplate(cartData, cartName, cartDate);
        });

        const emptyCartIds = allCarts
          .map(cart => {
            if (cart.cartData === null || cart.cartData.carts.length <= 0) {
              return cart.cartId;
            }
            return null;
          })
          .filter(cartId => cartId !== null);

        this.deleteAllEmptyCartsSequentially(emptyCartIds);

        htmlELements.forEach(result => {
          element.insertAdjacentHTML('beforeend', result);
        });
        element.classList.remove('is-loading');
        element.querySelectorAll('[data-module="appendCart"]').forEach(button => {
          button.addEventListener('click', event => this.setCart(event), true);
        });
        element.querySelectorAll('[data-module="deleteCart"]').forEach(button => {
          button.addEventListener('click', event => this.deleteCart(event), true);
        });
      } else {
        element.classList.remove('is-loading');
        element.insertAdjacentHTML('beforeend', `<p>Je hebt nog geen opgeslagen projecten.</p>`);
      }
    });
  }

  async deleteAllEmptyCartsSequentially(emptyCartIds) {
    for await (const cartId of emptyCartIds) {
      await this.deleteCartById(cartId, () => console.log('Empty cart deleted:', cartId));
    }
  }

  async deleteCartById(cartId, callback) {
    const savedCarts = await this.getCarts();
    savedCarts.forEach((cart, index) => {
      if (cart.cartId === cartId) {
        savedCarts.splice(index, 1);
      }
    });
    const json = encodeURI(JSON.stringify(savedCarts));
    const patchValue = JSON.parse(`[{"op": "replace","path": "/value","value": "${json}"}]`);
    await this.apiManager.patch('/api/v2/preference/user/savedCarts', patchValue);

    callback();
    return;
  }

  // helper functions
  // make date to display 'name day (01-01-1990)'
  static getCurrentDate() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // Januari is 0!

    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    today = `${dd}-${mm}-${yyyy}`;
    const date = new Date();
    const days = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

    return `${days[date.getDay()]} (${today})`;
  }

  // function to loop through the saved shopping cart and see if the current shopping cart already exists.
  static containsCartId(obj, list) {
    let found = false;
    for (let i = 0; i < list.length; i += 1) {
      if (list[i].cartId === obj.cartId) {
        found = true;
        break;
      }
    }
    return found;
  }
}

export default SaveShoppingCart;
